import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseConhecimentoDTO } from './base-conhecimento.dto';
import {GenericRoteirizadorService} from '../../services';
import {MensagensService} from 'max-ng-lib';

@Injectable({
  providedIn: 'root'
})
export class BaseConhecimentoService extends GenericRoteirizadorService {

  getUrlRecurso(): string {
    return '/baseConhecimento';
  }

  getMensagensService(): MensagensService {
    return this.mensagensService;
  }

  getHttpClient(): HttpClient {
    return this.httpClient;
  }
  constructor(
    private mensagensService: MensagensService,
    private httpClient: HttpClient) {
    super();
  }


  listarPaginas(id: string, exibirApenasComDescricao: boolean = false): Observable<BaseConhecimentoDTO[]> {
    return this.get<BaseConhecimentoDTO[]>(`/${id}/children?exibirApenasComDescricao=${exibirApenasComDescricao}`, {exibirLoading: false});
  }

  obterDescricaoArtigo(id: string): Observable<string> {
    return this.get<string>(`/${id}/descricao`, {exibirLoading: false});
  }

  excluirCacheArtigos() {
   return  this.delete('/excluir-artigos-cache', {exibirLoading: false});
  }
}
